/* eslint-disable */
import { DateTime } from 'luxon';

/* Get the current instant */
const now = DateTime.now();

export const notifications = [
    {
        idActiveEvent: null,
        severityLevel: 'info', // Simulazione di un livello di gravità
        notificationType: 'challenge',
        idUserSenderFk: '12345',
        username: 'System',
        eventTopic: 'Daily challenges',
        eventMsg: 'Your submission has been accepted',
        whenTimestamp: now.minus({ minute: 25 }).toISO(), // Simulazione di una data recente
    },
    {
        idActiveEvent: 'event-001',
        severityLevel: 'warning',
        notificationType: 'group_invite',
        idUserSenderFk: '67890',
        username: 'Leo Gill',
        eventTopic: 'Project Assignment',
        eventMsg:
            'Leo Gill added you to <em>Top Secret Project</em> and assigned you as a <em>Project Manager</em>',
        whenTimestamp: now.minus({ minute: 50 }).toISO(),
    },
    {
        idActiveEvent: null,
        severityLevel: 'info',
        notificationType: 'email',
        idUserSenderFk: '54321',
        username: 'Mailbox',
        eventTopic: 'New Emails',
        eventMsg: 'You have 15 unread mails across 3 mailboxes',
        whenTimestamp: now.minus({ hour: 3 }).toISO(),
    },
    {
        idActiveEvent: 'event-002',
        severityLevel: 'success',
        notificationType: 'system',
        idUserSenderFk: '99999',
        username: 'System',
        eventTopic: 'Cron jobs',
        eventMsg: 'Your <em>Docker container</em> is ready to publish',
        whenTimestamp: now.minus({ hour: 5 }).toISO(),
    },
];
